import { TOOLS_FETCH } from './actions.type';

import {
  TOOLS_SET,
  TOOLS_SHOW_ALL,
  TOOLS_FETCHED_SET,
  LEFT_RESIZABLE_PANEL_EXPAND_CHANGE,
  RIGHT_RESIZABLE_PANEL_EXPAND_CHANGE
} from './mutations.type';

import { Api as ApiNarzedzia } from '../api/api-ustawienia-systemowe';

const initialState = {
  tools: {},
  showAll: false,
  toolsFetched: false,
  control: null,
  leftResizablePanelExpanded: false,
  rightResizablePanelExpanded: false
};

const state = Object.assign({}, initialState);

const actions = {
  [TOOLS_FETCH](context) {
    const control = Date.now();
    const api = new ApiNarzedzia();

    context.commit('setToolsControl', control);

    api
      .getSettingsDostepnoscNarzedzi({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null
      })
      .then(response => {
        if (response) {
          context.commit(TOOLS_SET, response.body.dostepnosc_narzedzi);
        }
      })
      .catch(function(err) {
        context.commit(TOOLS_SHOW_ALL);
      })
      .finally(function() {
        context.commit(TOOLS_FETCHED_SET);
      });
  }
};

const mutations = {
  [TOOLS_SET](state, tools) {
    state.tools = {};
    state.showAll = false;
    tools.forEach(function(item) {
      state.tools[item.klucz] = item.status;
    });
  },
  [TOOLS_SHOW_ALL](state) {
    state.showAll = true;
  },
  [TOOLS_FETCHED_SET](state) {
    state.toolsFetched = true;
  },
  setToolsControl(state, control) {
    state.control = control;
  },
  [LEFT_RESIZABLE_PANEL_EXPAND_CHANGE](state, value) {
    state.leftResizablePanelExpanded = value;
  },

  [RIGHT_RESIZABLE_PANEL_EXPAND_CHANGE](state, value) {
    state.rightResizablePanelExpanded = value;
  }
};

const getState = key => {
  if (key in state.tools) {
    return state.tools[key];
  }
  return state.showAll;
};

const getters = {
  zoomInTool(state) {
    return getState('przybliz');
  },
  zoomOutTool(state) {
    return getState('oddal');
  },
  addressSearchTool(state) {
    return getState('wyszukiwarka_adresow');
  },
  moveForwardTool(state) {
    return getState('nastepny_widok');
  },
  moveBackTool(state) {
    return getState('poprzedni_widok');
  },
  setCentreTool(state) {
    return getState('zmiana_centrum_widoku');
  },
  demandFormTool(state) {
    return getState('zglaszanie_popytu');
  },
  demandExportTool(state) {
    return getState('eksport_popytu');
  },
  fullRangeTool(state) {
    return getState('caly_zasieg');
  },
  overviewMapTool(state) {
    return getState('mapa_przegladowa');
  },
  spatialTabsTool(state) {
    return getState('zakladki_przestrzenne');
  },
  objectSearchTool(state) {
    return getState('wyszukiwarka_obiektow');
  },
  metadataSearchTool(state) {
    return getState('wyszukiwarka_metadanych');
  },
  mapStateTool(state) {
    return getState('wyswietlenie_stanu_mapy_na_dany_dzien');
  },
  archivedDataRequestTool(state) {
    return getState('zglos_prosbe_o_dane_archiwalne');
  },
  addLayerFromServiceTool(state) {
    return getState('dodaj_warstwe_z_uslugi');
  },
  addLayerFromFileTool(state) {
    return getState('dodaj_warstwe_z_pliku');
  },
  roadLaneCostAnalysisTool(state) {
    return getState('analiza_kosztow_za_zajecie_pasa_drogowego');
  },
  polesCostAnalysisTool(state) {
    return getState('analiza_kosztow_za_wykorzystanie_slupow_energetycznych');
  },
  spatialAnalysisTool(state) {
    return getState('analizy_przestrzenne');
  },
  measurementTool(state) {
    return getState('pomiar');
  },
  editItemTool(state) {
    return getState('edycja_elementow');
  },
  copyItemTool(state) {
    return getState('kopiowanie_elementow');
  },
  selectItemTool(state) {
    return getState('selekcja_elementow');
  },
  addItemTool(state) {
    return getState('dodaj_obiekt');
  },
  removePermanentlyTool(state) {
    return getState('usun_obiekt');
  },
  moveToArchiveTool(state) {
    return getState('przenies_do_danych_archiwalnych');
  },
  reportDiscrepancyTool(state) {
    return getState('zglos_rozbieznosc');
  },
  exportToFileTool(state) {
    return getState('eksport_do_pliku');
  },
  generateReportTool(state) {
    return getState('generacja_raportu');
  },
  getTemplateTool(state) {
    return getState('pobierz_szablon');
  },
  adminPanelTool(state) {
    return getState('panel_zarzadzania');
  },
  keyboardShortcutsTool(state) {
    return getState('skroty_klawiszowe');
  },
  broadbandConnectivityAnalysisTool(state) {
    return getState('analiza_dostepu_do_laczy_szerokopasmowych');
  },
  anySearchTool(state) {
    return (
      getters.addressSearchTool(state) ||
      getters.metadataSearchTool(state) ||
      getters.objectSearchTool(state)
    );
  },
  toolsFetched(state) {
    return state.toolsFetched;
  },
  zoomToOwnRangeTool(state) {
    return getState('przybliz_do_wlasnego_zasiegu');
  },
  setFeatureGeometryTool(state) {
    return true;
  },
  reportDemand(state) {
    return getState('zglos_popyt');
  },
  leftResizablePanelExpanded(state) {
    return state.leftResizablePanelExpanded;
  },
  rightResizablePanelExpanded(state) {
    return state.rightResizablePanelExpanded;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
